window.addEventListener(
  "OneTrustGroupsUpdated",
  () => {
    const { performanceConsent } = getOneTrustConsent();
    const params = window.location.search.replaceAll("?", "").split("&");
    const refer = document.referrer;
    const paramObject = {};
    const currentTime = Date.now();
    let host = null;

    if (refer !== "") {
      let a = document.createElement("a");
      a.href = refer;
      host = a.hostname;
    }

    params.forEach((param) => {
      let item = param.split("=");
      if (item.length == 2) {
        paramObject[item[0]] = item[1];
      }
    });

    if (!localStorage.sessHist) {
      localStorage.sessHist = "[]";
    }

    if (localStorage.vT) {
      let oldSession = {};
      let allSessions = JSON.parse(localStorage.sessHist);
      oldSession.vT = localStorage.vT;
      if (localStorage.vS) {
        oldSession.vS = localStorage.vS;
      }
      if (localStorage.vM && localStorage.vS && localStorage.vS !== "direct") {
        oldSession.vM = localStorage.vM;
      }
      if (localStorage.vC && localStorage.vS && localStorage.vS !== "direct") {
        oldSession.vC = localStorage.vC;
      }
      if (localStorage.vCo && localStorage.vS && localStorage.vS !== "direct") {
        oldSession.vCo = localStorage.vCo;
      }
      allSessions.push(oldSession);
      localStorage.sessHist = JSON.stringify(allSessions);
    }

    if (
      refer == "https://www.birdygrey.com/" ||
      refer == "https://birdygrey.com/"
    ) {
      // DO NOTHING – THIS ISN'T A REAL SESSION
    } else if (
      params == "" ||
      (!paramObject.ar_channel && !paramObject.utm_source)
    ) {
      if (host !== "www.birdygrey.com" && host !== "birdygrey.com") {
        if (refer == "") {
          localStorage.vS = "direct";
          localStorage.vT = currentTime;
          if (localStorage.vM) {
            delete localStorage.vM;
          }
          if (localStorage.vC) {
            delete localStorage.vC;
          }
          if (localStorage.vCo) {
            delete localStorage.vCo;
          }
          if (!performanceConsent) {
            localStorage.iS = "direct";
            localStorage.iT = currentTime;
          }
        } else {
          localStorage.vS = refer;
          localStorage.vT = currentTime;
          if (localStorage.vM) {
            delete localStorage.vM;
          }
          if (localStorage.vC) {
            delete localStorage.vC;
          }
          if (localStorage.vCo) {
            delete localStorage.vCo;
          }

          localStorage.iS = refer;
          localStorage.iT = currentTime;
        }
      }
    } else {
      if (paramObject.ar_channel) {
        localStorage.vS = paramObject.ar_channel;
        localStorage.vM = "Ads";
        localStorage.vC = paramObject.ar_campaign;
        localStorage.vCo = paramObject.ar_ad;
        localStorage.vT = currentTime;
        if (!performanceConsent) {
          localStorage.iS = paramObject.ar_channel;
          localStorage.iM = "Ads";
          localStorage.iC = paramObject.ar_campaign;
          localStorage.iCo = paramObject.ar_ad;
          localStorage.iT = currentTime;
        }
      } else {
        localStorage.vS = paramObject.utm_source;
        localStorage.vM = paramObject.utm_medium;
        localStorage.vC = paramObject.utm_campaign;
        localStorage.vCo = paramObject.utm_content;
        localStorage.vT = currentTime;
        if (!performanceConsent) {
          localStorage.iS = paramObject.utm_source;
          localStorage.iM = paramObject.utm_medium;
          localStorage.iC = paramObject.utm_campaign;
          localStorage.iCo = paramObject.utm_content;
          localStorage.iT = currentTime;
        }
      }
    }

    const newAttribution = {
      event: "new_attribution_session",
    };

    if (localStorage.vT) {
      newAttribution.visit_timestamp = localStorage.vT;
    }

    if (localStorage.vS) {
      newAttribution.visit_source = localStorage.vS;
    }

    if (localStorage.vM && localStorage.vS && localStorage.vS !== "direct") {
      newAttribution.visit_medium = localStorage.vM;
    }

    if (localStorage.vC && localStorage.vS && localStorage.vS !== "direct") {
      newAttribution.visit_campaign = localStorage.vC;
    }

    if (localStorage.vCo && localStorage.vS && localStorage.vS !== "direct") {
      newAttribution.visit_content = localStorage.vCo;
    }

    gtag(newAttribution);

    const lcInput = document.getElementById("lc-source-input");

    if (lcInput) {
      if (localStorage.sessHist && localStorage.sessHist.length > 0) {
        let input = document.getElementById("session-history-input");
        input.disabled = false;
        input.value = localStorage.sessHist;
      }
      if (localStorage.atc_attribution) {
        let input = document.getElementById("atc-history-input");
        input.disabled = false;
        input.value = localStorage.atc_attribution;
      }
      if (localStorage.iS) {
        let input = document.getElementById("ic-source-input");
        input.disabled = false;
        input.value = localStorage.iS;
      }
      if (localStorage.iT) {
        let input = document.getElementById("ic-timestamp-input");
        input.disabled = false;
        input.value = localStorage.iT;
      }
      if (localStorage.iM) {
        let input = document.getElementById("ic-medium-input");
        input.disabled = false;
        input.value = localStorage.iM;
      }
      if (localStorage.iC) {
        let input = document.getElementById("ic-campaign-input");
        input.disabled = false;
        input.value = localStorage.iC;
      }
      if (localStorage.iCo) {
        let input = document.getElementById("ic-content-input");
        input.disabled = false;
        input.value = localStorage.iCo;
      }
      if (localStorage.vS) {
        let input = document.getElementById("lc-source-input");
        input.disabled = false;
        input.value = localStorage.vS;
      }
      if (localStorage.vT) {
        let input = document.getElementById("lc-timestamp-input");
        input.disabled = false;
        input.value = localStorage.vT;
      }
      if (localStorage.vM && localStorage.vS && localStorage.vS !== "direct") {
        let input = document.getElementById("lc-medium-input");
        input.disabled = false;
        input.value = localStorage.vM;
      }
      if (localStorage.vC && localStorage.vS && localStorage.vS !== "direct") {
        let input = document.getElementById("lc-campaign-input");
        input.disabled = false;
        input.value = localStorage.vC;
      }
      if (localStorage.vCo && localStorage.vS && localStorage.vS !== "direct") {
        let input = document.getElementById("lc-content-input");
        input.disabled = false;
        input.value = localStorage.vCo;
      }
    }

    const olderSessions = JSON.parse(localStorage.sessHist);

    if (olderSessions.length > 0 && olderSessions[0].vT) {
      let usableSessions = olderSessions.filter(
        (session) => currentTime - session.vT > 1800000,
      );
      if (olderSessions !== usableSessions) {
        localStorage.sessHist = JSON.stringify(usableSessions);
      }
    }
  },
  false,
);
